module.exports = __webpack_public_path__ + "media/images/loghi/predictor_wrong-abc98d14030fcdb2bd90c0cacf26036c.svg";